import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import Renderable from '../../../Component/Renderable';

export class WheelLightBulbs extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        meta.bulbs.forEach((bulb: GameObject, index: number) => {
            const renderable: Renderable = bulb.getComponent(Renderable);

            const alpha0 = index % 2 === 0 ? 1 : 0;
            const alpha1 = index % 2 !== 0 ? 1 : 0;

            renderable.visible = true;
            renderable.alpha = alpha0;
    
            const tween = this.getTween(renderable);
            tween
                .to({ alpha: alpha1 }, 200)
                .easing(Easing.Quadratic.InOut)
                .yoyo(true)
                .repeat(Infinity)
                .start(this.elapsedTime);
        });

        while (true) yield;
    }
}
